import { isMobile } from 'react-device-detect';

import { Box } from 'shared/ui/Box';
import { Spinner } from 'shared/ui/Spinner';
import { HeaderSkeleton } from 'widgets/header';
import { Layout } from 'widgets/layout';
import { MobileHeaderSkeleton } from 'widgets/mobileHeader';
import { SidebarSkeleton } from 'widgets/navigationBar';

export const PageFallback = () => (
  <Box height='100vh' width='100vw' display='flex' justifyContent='center' alignItems='center'>
    <Layout sidebar={isMobile ? <></> : <SidebarSkeleton />} header={isMobile ? <MobileHeaderSkeleton /> : <HeaderSkeleton />}>
      <Box display='flex' justifyContent='center'>
        <Spinner />
      </Box>
    </Layout>
  </Box>
);
